// src/config/api.config.ts
export const API_CONFIG = {
  BASE_URL: process.env.VITE_API_BASE_URL || 'https://lex.edgelex.com',
  API_VERSION: 'v1',
  ENDPOINTS: {
    // DMS (Document Management System) - Contact & Matter APIs
    DMS: {
      CLIENTS: '/api/v1/dms/clients',
      MATTERS: '/api/v1/dms/matters',
      DOCUMENTS: '/api/v1/dms/documents',
    },
    // Intake Management APIs
    INTAKE: {
      ENHANCED: '/api/v1/enhanced-intake',
      LEGACY: '/api/v1/intake',
      FORMS: '/api/v1/intake/forms',
      SUBMISSIONS: '/api/v1/intake/submissions',
    },
    // Authentication & User Management
    AUTH: {
      LOGIN: '/auth/login',
      LOGOUT: '/auth/logout',
      REFRESH: '/auth/refresh',
      USER_INFO: '/auth/userinfo',
    },
    // Job Monitoring (existing)
    JOBS: {
      QUEUE: '/api/v1/jobs',
      METRICS: '/api/v1/queue-metrics',
      STATUS: '/api/v1/jobs/status',
    },
    // Tasks
    TASKS: '/api/v1/tasks',
    // Projects (existing)
    PROJECTS: '/api/v1/projects',
  },
  TIMEOUT: 30000, // 30 seconds
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000, // 1 second
} as const;

// Environment-specific overrides
export const getApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Request headers factory
export const getDefaultHeaders = (token?: string): Record<string, string> => {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return headers;
};

// API Response Types
export interface ApiResponse<T = unknown> {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
  timestamp?: string;
}

export interface PaginatedResponse<T> extends ApiResponse<T[]> {
  pagination?: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

// Standard API Error Types
export interface ApiError {
  status: number;
  message: string;
  code?: string;
  details?: unknown;
}

export class ApiException extends Error {
  constructor(
    public status: number,
    message: string,
    public code?: string,
    public details?: unknown
  ) {
    super(message);
    this.name = 'ApiException';
  }
}
